import { useMutation, useQueryClient } from '@tanstack/react-query'
import { DateTime } from 'luxon'

import { useWallet } from '~/lib/useWallet'
import { getVotingEscrowContract } from '~/contracts/getVotingEscrowContract'
import { useVESISParams } from '~/hooks/useVESISParams'

import type { Locked } from '../useLockChangeDetails'

export function useIncreaseUnlockTime(locked: Locked, duration: number) {
	const { config, provider } = useVESISParams()

	const { signer, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async () => {
			if (!duration || !locked) {
				return
			}

			const contract = getVotingEscrowContract(config, provider).connect(
				signer
			)

			const unlockTime = DateTime.fromSeconds(locked.end.toNumber())
				.plus({ weeks: duration })
				.toUnixInteger()

			const tx = await contract.increase_unlock_time(
				unlockTime.toString()
			)

			await tx.wait()
		},
		onSuccess() {
			queryClient.resetQueries({ queryKey: ['sis-lock'] })
		},
		onError(error) {
			console.error('Error increasing unlock time:', error)
		},
	})
}
